import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MainWrapper from './Main.style';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import Dashboard from './Dashboard/Dashboard';
import AddUser from '../Users/AddUser/AddUser';
import UpdateUser from '../Users/UpdateUser/UpdateUser';
import AddICConfig from '../IC/AddICConfig/AddICConfig';
import UpdateICConfig from '../IC/UpdateICConfig/UpdateICConfig';
import UploadFile from '../IC/UploadFile/UploadFile';
import PublishFiles from '../IC/PublishFiles/PublishFiles';
import DownloadData from '../IC/DownloadData/DownloadData';
import AddConfigParameters from '../Miscellaneous/AddConfigParemeters/AddConfigParameters';
import AddClient from '../Client/AddClient/AddClient';
import UpdateClient from '../Client/UpdateClient/UpdateClient';
import UploadBoxFiles from '../Box/UploadBoxFiles/UploadBoxFiles';
import Reports from '../Box/Reports/Reports';
import AssignReports from '../Box/AssignReports/AssignReports';
import Chats from '../Box/Chats/Chats';

class Main extends React.Component {
    render() {
        let routes;
        if (this.props.LOGINREDUCER.USER.role === "SUPERADMIN") {
            routes = [
                <Route key={1} exact path='/home' component={Dashboard} />,
                <Route key={2} exact path='/home/users/add' component={AddUser} />,
                <Route key={3} exact path='/home/users/update' component={UpdateUser} />,
                <Route key={4} exact path='/home/ic/config-add' component={AddICConfig} />,
                <Route key={5} exact path='/home/ic/file-upload' component={UploadFile} />,
                <Route key={6} exact path='/home/ic/config-update' component={UpdateICConfig} />,
                <Route key={7} exact path='/home/ic/file-publish' component={PublishFiles} />,
                <Route key={8} exact path='/home/ic/download-data' component={DownloadData} />,
                <Route key={9} exact path='/home/misc/config-parameters' component={AddConfigParameters} />,
                <Route key={10} exact path='/home/client/add' component={AddClient} />,
                <Route key={11} exact path='/home/client/update' component={UpdateClient} />,
                <Route key={12} exact path='/home/box/file-upload' component={UploadBoxFiles} />,
                <Route key={13} exact path='/home/box/attach-reports' component={Reports} />,
                <Route key={14} exact path='/home/box/customization' render={() => <Chats from="customization" />} />,
                <Route key={15} exact path='/home/box/assign-reports' render={() => <AssignReports from="assign-reports" />} />,
                <Route key={16} exact path='/home/box/chats' render={() => <Chats from="chats" />} />
            ];
        }
        else if (this.props.LOGINREDUCER.USER.role === "ADMIN") {
            routes = [
                <Route key={1} exact path='/home' component={Dashboard} />,
                <Route key={2} exact path='/home/users/add' component={AddUser} />,
                <Route key={3} exact path='/home/users/update' component={UpdateUser} />,
                <Route key={4} exact path='/home/ic/config-add' component={AddICConfig} />,
                <Route key={5} exact path='/home/ic/file-upload' component={UploadFile} />,
                <Route key={6} exact path='/home/ic/config-update' component={UpdateICConfig} />,
                <Route key={7} exact path='/home/ic/file-publish' component={PublishFiles} />,
                <Route key={8} exact path='/home/ic/download-data' component={DownloadData} />,
                <Route key={9} exact path='/home/misc/config-parameters' component={AddConfigParameters} />,
                <Route key={10} exact path='/home/client/add' component={AddClient} />,
                <Route key={11} exact path='/home/client/update' component={UpdateClient} />,
                <Route key={12} exact path='/home/box/file-upload' component={UploadBoxFiles} />,
                <Route key={13} exact path='/home/box/attach-reports' render={() => <Reports from='reports' />} />,
                <Route key={14} exact path='/home/box/customization' render={() => <Chats from="customization" />} />,
                <Route key={15} exact path='/home/box/assign-reports' render={() => <AssignReports from="assign-reports" />} />,
                <Route key={16} exact path='/home/box/chats' render={() => <Chats from="chats" />} />
            ];
        }
        else if (this.props.LOGINREDUCER.USER.role === "NONADMIN") {
            routes = [
                <Route key={1} exact path='/home' component={Dashboard} />,
                <Route key={2} exact path='/home/ic/config-add' component={AddICConfig} />,
                <Route key={3} exact path='/home/ic/config-update' component={UpdateICConfig} />,
                <Route key={4} exact path='/home/ic/file-upload' component={UploadFile} />,
                <Route key={5} exact path='/home/ic/file-publish' component={PublishFiles} />,
                <Route key={6} exact path='/home/ic/download-data' component={DownloadData} />
            ];
        }
        else if (this.props.LOGINREDUCER.USER.role === "SALES") {
            routes = [
                <Route key={1} exact path='/home' component={Dashboard} />,
                <Route key={2} exact path='/home/client/add' component={AddClient} />
            ];
        }

        return (
            <MainWrapper>
                <Header />
                <div className="content">
                    <Switch>
                        {routes}
                    </Switch>
                </div>
                <Footer />
            </MainWrapper>
        )
    }
}

function mapToStateProps(state) {
    return state;
}

const mapDispatchToProps = {

}

export default withRouter(connect(mapToStateProps, mapDispatchToProps)(Main));


// WEBPACK FOOTER //
// ./src/components/Main/Main.js